import ConfirmDialog from "../components/confirm-dialog";
import { useDeleteModel } from "../store/use-delete-model";

interface TDeleteModel {
  loading: boolean;
}

const DeleteModel = ({ loading = false }: TDeleteModel) => {
  const { onCloseDeletePopup, initialValues } = useDeleteModel();

  return (
    <ConfirmDialog
      title="Are you sure you want to delete this chase?"
      description="This permanently removes the chase and its history. It cannot be undone."
      confirmLabel="Delete"
      tone="danger"
      loading={loading}
      onConfirm={initialValues.onClick}
      onCancel={onCloseDeletePopup}
    />
  );
};

export default DeleteModel;
